export const environment = {
  apiUrl: 'https://api.mia.lanars-dev.com/',
  apiVersion: 'v1',
  healthApiUrl: 'https://dev.health-api.mementoportal.com/',
  healthApiVersion: 'v2',
  portalApiUrl: 'https://dev-health-api.miahealth.no/',
  portalApiVersion: 'v3',
  organizationKey: 'miadev',
  production: false,
  mapsPublicKey: 'AIzaSyBoH9SpF0r3ty2L1CRp37LxZduGZ3m9MlY',
  webInsightsUrl: 'https://community-insights.miahealth.no',
  webInsightsEnvironment: 'dev',
  SOCKET_URL: 'https://chats.mia.lanars-dev.com',
};
